import React from 'react';
import { Box, Tooltip } from '@mui/material';
import moment from 'moment';
import { MdOutlineDelete, MdOutlineFileDownload, MdOutlineVisibility } from 'react-icons/md';
import { getFileIcon, getFileName } from 'src/pages/CandidateDocuments/utils';
import { DocumentResponse } from 'src/pages/CandidateDocuments/types';

export interface JobDocumentsListProps {
  documentList: DocumentResponse[];
  onDocumentDownload: (doc: DocumentResponse) => void;
  onDocumentView: (doc: DocumentResponse) => Promise<void>;
  onDocumentDelete: (doc: DocumentResponse) => Promise<void>;
}

function JobDocumentsList(props: JobDocumentsListProps) {
  const {
    documentList,
    onDocumentDownload,
    onDocumentView,
    onDocumentDelete,
  } = props;

  if (documentList.length === 0) {
    return (
      <Box className="bg-white p-4 my-1 rounded text-sm text-[#828A97]">
        No documents uploaded
      </Box>
    );
  }

  return (
    <Box>
      {documentList.map((doc, index) => {
        const Icon = getFileIcon(doc.documentName);
        const { name } = getFileName(doc.documentName, 40);

        return (
          <Box
            key={doc.documentId ?? index}
            className="bg-white p-5 my-1 rounded group flex items-center gap-4"
          >
            <Box className="flex shrink-0 items-center">
              <Icon className="w-7 h-7 text-secondary" />
            </Box>
            <Box className="min-w-0 flex-1">
              <Tooltip title={doc.documentName}>
                <Box className="font-medium text-md leading-5 break-all">{name}</Box>
              </Tooltip>
              <Box className="text-xs leading-5 text-[#828A97] mt-1">
                {doc.updatedDate
                  ? moment(doc.updatedDate).format('MM/DD/YYYY hh:mm A')
                  : '-'}
              </Box>
            </Box>
            <Box className="flex shrink-0 items-center gap-2 opacity-0 group-hover:opacity-100">
              <Tooltip title="Download">
                <button
                  type="button"
                  className="border-none cursor-pointer bg-transparent"
                  onClick={() => onDocumentDownload(doc)}
                >
                  <MdOutlineFileDownload className="w-5 h-5 text-secondary" />
                </button>
              </Tooltip>
              <Tooltip title="Preview">
                <button
                  type="button"
                  className="border-none cursor-pointer bg-transparent"
                  onClick={() => onDocumentView(doc)}
                >
                  <MdOutlineVisibility className="w-5 h-5 text-secondary" />
                </button>
              </Tooltip>
              {doc.documentId != null && (
                <Tooltip title="Delete">
                  <button
                    type="button"
                    className="border-none cursor-pointer bg-transparent"
                    onClick={() => onDocumentDelete(doc)}
                  >
                    <MdOutlineDelete className="w-5 h-5 text-secondary" />
                  </button>
                </Tooltip>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default JobDocumentsList;
